<template>
  <div class="campaign-points-table">
    <div class="row filters mb-4">
      <div class="col-2">
        <app-input
          @input="onInput"
          v-model="filters.term"
          placeholder="Pesquisar"
        ></app-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-table
          :data="data"
          :loading="loading"
          paginated
          backend-pagination
          :total="total"
          :per-page="perPage"
          @page-change="onPageChange"
          aria-next-label="Próxima Página"
          aria-previous-label="Página Anterior"
          aria-page-label="Página"
          aria-current-label="Página Atual"
        >
          <template slot-scope="props">
            <b-table-column field="ean" label="Cód. EAN">{{
              props.row.product.ean_code
            }}</b-table-column>

            <b-table-column field="code" label="Código">{{
              props.row.product.code
            }}</b-table-column>

            <b-table-column field="points" label="Pontos">{{
              props.row.points | number
            }}</b-table-column>

            <b-table-column field="name" label="Produto">{{
              props.row.product.name
            }}</b-table-column>

            <b-table-column label="Opções">
              <router-link
                tag="button"
                :to="`${props.row.id}/edit`"
                v-app-button.icon-only
                v-tooltip.bottom="'Editar'"
              >
                <b-icon size="is-small" icon="pencil"></b-icon>
              </router-link>
              <button
                @click="onClickDeletePoint(props.row.id)"
                v-app-button.icon-only
                color="danger"
                v-tooltip.bottom="'Excluir'"
              >
                <b-icon size="is-small" icon="delete"></b-icon>
              </button>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>Nenhum registro encontrado.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignPointService from '@/services/campaign-points.service.js';
import ToastMixin from '@/mixins/ToastifyMixin';

import debounce from 'lodash/debounce';

export default {
  name: 'campaign-points-table',
  mixis: [ToastMixin],
  props: ['campaignId'],
  data: () => {
    return {
      data: [],
      filters: {},
      datesFilter: null,
      loading: false,
      total: 0,
      page: 1,
      perPage: 10,
    };
  },
  methods: {
    load() {
      this.loading = true;

      CampaignPointService.getByCampaign(this.campaignId, {
        page: this.page,
        perPage: this.perPage,
        ...this.filters,
      })
        .then((response) => {
          const { total, data } = response.data;

          this.total = total;
          this.data = data;
        })
        .catch(() => this.toastify('Erro ao carregar Pontos.', 'error'))
        .finally(() => (this.loading = false));
    },
    onInput: debounce(function () {
      this.load();
    }, 400),
    onPageChange(page) {
      this.page = page;
      this.load();
    },
    edit(id) {
      this.$router.push(`${id}/edit`);
    },
    onClickDeletePoint(id) {
      this.$buefy.dialog.confirm({
        title: 'Excluindo Ponto',
        message:
          'Tem certeza que deseja <b>excluir</b> este Ponto? Essa ação não pode ser desfeita.',
        cancelText: 'Cancelar',
        confirmText: 'Excluir Ponto',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteCampaignPoint(id),
      });
    },
    deleteCampaignPoint(id) {
      CampaignPointService.delete(id)
        .then(() => {
          this.toastify('Ponto excluído com sucesso.');
          this.load();
        })
        .catch(({ response }) => {
          this.toastify(
            response.data.message || 'Erro ao tentar excluir Ponto.',
            'error'
          );
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
